module.exports = __webpack_public_path__ + "static/media/Avatar3.1b640422.png";